(() => {
  const setup = (scope = document) => {
    scope.querySelectorAll('[data-sign-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const paused = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelectorAll('.phm-led-sign__messages strong, .phm-led-sign__mark svg').forEach(element => { element.style.animationPlayState = paused ? 'paused' : ''; });
      });
    });
    scope.querySelectorAll('[data-video-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const video = button.closest('.hero-media')?.querySelector('video');
      if (!video) return;
      const update = () => {
        button.textContent = video.paused ? button.dataset.play : button.dataset.pause;
        button.setAttribute('aria-pressed', String(!video.paused));
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      button.addEventListener('click', () => video.paused ? video.play().catch(update) : video.pause());
      update();
    });
    scope.querySelectorAll('.mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
        if (event.key === 'Tab' && menu.open) {
          const controls = [...menu.querySelectorAll('summary,a[href],button')];
          const first = controls[0], last = controls.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      const wide = matchMedia('(min-width: 750px)');
      wide.addEventListener('change', () => { if (wide.matches) menu.open = false; });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('video').forEach(video => video.pause()));
})();

(() => {
const instances=new WeakMap();
function init(root=document){root.querySelectorAll('[data-lookbook="slider"]').forEach(section=>{
if(instances.has(section))return;const track=section.querySelector('.media-grid'),prev=section.querySelector('[data-look-prev]'),next=section.querySelector('[data-look-next]');if(!track||!prev||!next)return;
const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
const move=direction=>{const card=track.querySelector('.media-tile');track.scrollBy({left:direction*((card?.getBoundingClientRect().width||200)+parseFloat(getComputedStyle(track).gap||0)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
const observer=new ResizeObserver(update);observer.observe(track);instances.set(section,observer);update();});}
init();document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-lookbook]').forEach(s=>instances.get(s)?.disconnect()));document.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.media-tile');if(card?.closest('[data-lookbook="slider"]')){const track=card.parentElement;track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:'instant'});}});
})();

(() => {
document.addEventListener('click',event=>{const button=event.target.closest('[data-marquee-toggle]');if(!button||matchMedia('(prefers-reduced-motion:reduce)').matches)return;const paused=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);});
document.addEventListener('shopify:section:select',event=>event.target.querySelectorAll('[data-marquee]').forEach(el=>el.setAttribute('data-editor-selected','')));
document.addEventListener('shopify:section:deselect',event=>event.target.querySelectorAll('[data-marquee]').forEach(el=>el.removeAttribute('data-editor-selected')));
})();
